import { render, staticRenderFns } from "./b33.vue?vue&type=template&id=1f6e0880&scoped=true"
import script from "./b33.vue?vue&type=script&lang=js"
export * from "./b33.vue?vue&type=script&lang=js"
import style0 from "./b33.vue?vue&type=style&index=0&id=1f6e0880&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e0880",
  null
  
)

export default component.exports